import { Navigate, useTypedParams } from '@sorare/routing';

import { ANY_SPORT_MY_CLUB_SLUG } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { PageParams } from './__generated__/routeParams';

const MyClubRedirect = () => {
  const { generateSportContextPath } = useSportContext();
  const { slug } = useTypedParams<PageParams>();

  return (
    <Navigate
      replace
      to={generateSportContextPath(ANY_SPORT_MY_CLUB_SLUG, {
        params: {
          slug,
        },
      })}
    />
  );
};

export default MyClubRedirect;
